import React from 'react';
import { Text } from './typography/Text';
export const Divider = ({ label, className }) => {
    return (React.createElement("div", { className: `cb-divider-container ${className ? ` ${className}` : ''}` },
        React.createElement("div", { className: 'cb-divider-line' }),
        React.createElement("div", { className: 'cb-divider-text' },
            React.createElement(Text, { level: '1', textColorVariant: 'script', fontWeight: 'normal', className: 'cb-row' }, label)),
        React.createElement("div", { className: 'cb-divider-line' })));
};
